import React from 'react';

export const CardSkeleton: React.FC = () => {
  return (
    <div className="bg-card p-6 rounded-lg border shadow-sm animate-pulse">
      {/* Title skeleton */}
      <div className="h-5 w-32 bg-gray-200 dark:bg-gray-700 rounded mb-4"></div>

      {/* Value skeleton */}
      <div className="h-9 w-20 bg-gray-200 dark:bg-gray-700 rounded mb-3"></div>

      {/* Change text skeleton */}
      <div className="flex items-center gap-2">
        <div className="h-4 w-4 bg-gray-200 dark:bg-gray-700 rounded"></div>
        <div className="h-4 w-24 bg-gray-200 dark:bg-gray-700 rounded"></div>
      </div>
    </div>
  );
};
